export default __webpack_public_path__ + "static/media/MH-Gen-AI-Small-lite.f34c596a.png";